import React from 'react';
import { FaFacebookF, FaYoutube } from 'react-icons/fa';
import {
    Container,
    Content,
    FooterCollumn,
    FooterBottom,
    FooterCopyright,
} from './styles';

import logo from '~/assets/images/logo.svg';

function Footer() {
    return (
        <Container>
            <Content>
                <FooterCollumn>
                    <img src={logo} alt="Rastreamento by Mercado Mail" />
                    <p>
                        Serviço de rastreio gratuito com conexão direta ao
                        sistema dos correios e JadLog, informações atualizadas
                        em tempo real.
                    </p>
                    <p>
                        As atualizações serão mostradas conforme disponibilidade
                        no sistema das transportadoras.
                    </p>
                </FooterCollumn>
                <FooterCollumn />
                <FooterCollumn />
            </Content>
            <FooterBottom>
                <FooterCopyright>
                    <div>
                        <p>
                            © 2020 by
                            <a
                                href="http://www.mercadoturbo.com.br"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Mercado Turbo
                            </a>
                        </p>
                    </div>
                    <div className="social-container">
                        <a
                            href="https://www.facebook.com/mercadomailbrasil/"
                            data-effect="fadeInUp"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaFacebookF />
                        </a>
                        <a
                            href="https://www.youtube.com/channel/UCA3x81dO95hsexJaIQef_bQ"
                            data-effect="fadeInUp"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaYoutube />
                        </a>
                    </div>
                </FooterCopyright>
            </FooterBottom>
        </Container>
    );
}

export default Footer;
